function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".input-handle-1{fill:#ff690f;}.input-handle-2{fill:#292929;}.input-handle-3{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Landing_w_Project",
  "data-name": "Landing w/ Project"
}, /*#__PURE__*/React.createElement("path", {
  className: "input-handle-1",
  d: "M38.12,3.87a5,5,0,0,1-5,5A4.93,4.93,0,0,1,30.36,8a15.41,15.41,0,0,1-3.25-3.31,15.62,15.62,0,0,1,2.52,7.73v1.38a16.46,16.46,0,0,1-2.52,7.71,15.64,15.64,0,0,1,2.64-2.78h0a4.93,4.93,0,0,1,3.36-1.32,5,5,0,0,1,5,4.83h0V15.32h0V10.85c-.32,0-.63,0-1-.06q.48,0,1,.06Zm-7,4.69c-.26-.17-.51-.35-.76-.54C30.65,8.21,30.9,8.39,31.16,8.56Zm1.68,1-.54-.28ZM32,9.06c-.21-.12-.42-.24-.62-.37C31.56,8.82,31.77,8.94,32,9.06Zm-.85,8.63.08-.06Zm5-2.16.6-.1Zm-3,1,.22-.1Zm.8-.35.36-.13Zm.91-.32c.27-.09.55-.16.83-.23A7.84,7.84,0,0,0,34.9,15.85Zm2.23-.47c.31,0,.61-.06.91-.06C37.74,15.32,37.44,15.35,37.13,15.38Zm-.92-4.73.66.11Zm-3-1c.21.1.42.19.64.27C33.6,9.87,33.39,9.78,33.18,9.68Zm.88.37c.29.11.59.21.88.3C34.65,10.26,34.35,10.16,34.06,10.05Zm1.17.38.65.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "input-handle-2",
  d: "M13.09,24.18A11.09,11.09,0,1,1,24.18,13.09,11.11,11.11,0,0,1,13.09,24.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "input-handle-1",
  d: "M13.09,4A9.09,9.09,0,1,1,4,13.09,9.1,9.1,0,0,1,13.09,4m0-4A13.09,13.09,0,1,0,26.18,13.09,13.09,13.09,0,0,0,13.09,0Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "input-handle-3",
  x: 6.15,
  y: 12.17,
  width: 9.29,
  height: 1.83
}), /*#__PURE__*/React.createElement("polygon", {
  className: "input-handle-3",
  points: "20.15 13.09 17.74 15.01 15.32 16.93 15.32 13.09 15.32 9.25 17.74 11.17 20.15 13.09"
})));

function SvgInputHandle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.12 26.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputHandle);
export default __webpack_public_path__ + "static/media/InputHandle.441f17be.svg";
export { ForwardRef as ReactComponent };